import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { AnalyticsService } from '@core/services/analytics.service';

export function provideAnalytics(): EnvironmentProviders {
  return makeEnvironmentProviders([provideAppInitializer(() => inject(AnalyticsService).init())]);
}
